import { lazyPage } from '@/lib/lazy-page'

import HomePage from '@/views/HomePage/HomePage'
import ServicesPage from '@/views/ServicesPage/ServicesPage'
import ServiceDetailPage from '@/views/ServicesPage/ServiceDetailPage'
import PortfolioPage from '@/views/PortfolioPage/PortfolioPage'
import CaseStudyPage from '@/views/WorkPage/CaseStudyPage'
import ContactPage from '@/views/ContactPage/ContactPage'
import ConnectPage from '@/views/ConnectPage/ConnectPage'
import BlogIndexPage from '@/views/BlogIndexPage'
import BlogPostPage from '@/views/BlogPostPage'
import PrivacyPolicyPage from '@/views/PrivacyPolicyPage/PrivacyPolicyPage'
import PetsDemoGallery from '@/views/Demos/PetsDemoGallery'
import PetDemoPage from '@/views/Demos/PetDemoPage'

import SiteLayout from '@/layouts/SiteLayout'

import { Navigate, Route, Routes } from '@/lib/router'

// Admin: kept out of the public-site entry chunk - nothing here loads until
// a visitor actually navigates to /admin.
const AdminRootLayout = lazyPage(() => import('@/layouts/AdminRootLayout'))
const AdminDashboardLayout = lazyPage(() => import('@/layouts/AdminDashboardLayout'))
const AdminLogin = lazyPage(() => import('@/views/Admin/AdminLogin'))
const ProjectsPage = lazyPage(() => import('@/views/Admin/ProjectsPage'))
const ProjectDetailPage = lazyPage(() => import('@/views/Admin/ProjectDetailPage'))
const LeadsPage = lazyPage(() => import('@/views/Admin/LeadsPage'))
const CustomersPage = lazyPage(() => import('@/views/Admin/CustomersPage'))
const RemindersPage = lazyPage(() => import('@/views/Admin/RemindersPage'))
const FbaPage = lazyPage(() => import('@/views/Admin/FbaPage'))
const BlogAdminPage = lazyPage(() => import('@/views/Admin/BlogAdminPage'))
const LeadGenPage = lazyPage(() => import('@/views/LeadGen'))
const CampaignBuilder = lazyPage(() => import('@/views/LeadGen/CampaignBuilder'))
const NameGeneratorPage = lazyPage(() => import('@/views/Admin/NameGeneratorPage'))

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="services/:slug" element={<ServiceDetailPage />} />
        <Route path="portfolio" element={<PortfolioPage />} />
        <Route path="work/:slug" element={<CaseStudyPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="connect" element={<ConnectPage />} />
        <Route path="blog" element={<BlogIndexPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="demos/pets" element={<PetsDemoGallery />} />
        <Route path="demos/pets/:id" element={<PetDemoPage />} />
      </Route>

      <Route path="admin" element={<AdminRootLayout />}>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<AdminDashboardLayout />}>
          <Route index element={<ProjectsPage />} />
          <Route path="projects/:projectId" element={<ProjectDetailPage />} />
          <Route path="leads" element={<LeadsPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="reminders" element={<RemindersPage />} />
          <Route path="fba" element={<FbaPage />} />
          <Route path="blog" element={<BlogAdminPage />} />
          <Route path="lead-gen" element={<LeadGenPage />} />
          <Route path="lead-gen/campaign" element={<CampaignBuilder />} />
          <Route path="lead-gen/:leadId" element={<LeadGenPage />} />
          <Route path="name-generator" element={<NameGeneratorPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
